import React, { Component } from 'react';
import cx from 'classnames';

import FormInputLabel from './form-input-label';

class Dropdown extends Component {
  constructor(props) {
    super(props);

    const { defaultOption } = this.props;

    const isDefaultOption = defaultOption !== undefined && defaultOption !== null;
    let selectedOption = null;

    if (isDefaultOption) {
      selectedOption = defaultOption;
    }

    this.state = {
      inFocus: false,
      selectedOption: selectedOption,
    };

    /* Event Handlers */

    this.handleBlur = this.handleBlur.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
  }

  componentDidMount() {
    const { onChange, options } = this.props;
    const { selectedOption } = this.state;
    // Initial value
    if (onChange && selectedOption) {
      onChange(options[selectedOption].props.value);
    }
  }

  render() {
    const {
      autocompleteName,
      checkIcon,
      className,
      input,
      isDisabled,
      isRequired,
      isOnDarkBackground,
      options,
      placeholder,
      label,
      labelCopyID,
      labelClassModifier,
      dropdownSelectRef,
      tabIndex,
    } = this.props;

    const {
      inFocus,
      selectedOption,
    } = this.state;

    let option = (selectedOption !== null && options?.[selectedOption]?.name) || '';
    const valueSelected = (selectedOption !== null && options?.[selectedOption]?.value) ? options[selectedOption].value : '';
    option = option === '' ? placeholder : option;
    const dropdownSelect = cx({
      'Dropdown-select': true,
      'Dropdown-select-isText': labelCopyID ? true : false,
    });

    const dropdownClasses = cx({
      'Dropdown': labelCopyID ? false : true,
      'Dropdown-withLabel': labelCopyID ? true : false,
      'Dropdown--darkBkgd': isOnDarkBackground,
      'is-disabled': isDisabled,
      'is-inactive': typeof selectedOption === 'undefined',
      'is-inFocus': inFocus,
    }, className);

    return (
      <div className={ dropdownClasses }>
        { labelCopyID ? <FormInputLabel
          name={ name }
          isRequired={ isRequired }
          label={ label }
          labelClassModifier={ labelClassModifier }
          labelCopyID={ labelCopyID } /> : null }
        <div className='Dropdown-listTrigger'>
          <span className='Dropdown-selectedText'>{ option }</span>
          <span className='Dropdown-icon Icon Icon--arrowSmallDown'></span>
        </div>
        <select
          aria-hidden={ true }
          aria-disabled={ isDisabled }
          autoComplete={ autocompleteName }
          className={ dropdownSelect }
          { ...input }
          onChange={ (e) => this.handleOptionSelect(e) }
          onBlur={ this.handleBlur }
          onFocus={ this.handleFocus }
          ref={ dropdownSelectRef ? dropdownSelectRef : null }
          tabIndex={ isDisabled ? -1 : tabIndex }
          value={ valueSelected }>
          { this.renderSelectOptions(valueSelected) }
        </select>
        { option && checkIcon  ? <span className='FormInput-correct-dropdown Icon Icon--check' /> : null }
      </div>
    );
  }

  renderSelectOptions(valueSelected) {
    const { options, placeholder } = this.props;
    const selectOptions = options.map((option, i) =>
      (<option
        disabled={ option.disabled ? option.disabled : false }
        key={ i }
        value={ option.value }>
        { this.getOptionText(option) }
      </option>)
    );

    if (valueSelected === '') {
      selectOptions.unshift((
        <option
          key='noSelectedItem'
          disabled={ true }
          hidden={ true }
          value=''>
          { placeholder ? placeholder : '' }
        </option>
      ));
    }
    return selectOptions;
  }

  getOptionText(option) {
    const { helperTraslatedCopy, placeholder } = this.props;

    if (option.copyID) {
      return helperTraslatedCopy.getFormatMessageFromcopyId(option.copyID);
    } else if (option.name) {
      return option.name;
    } else if (placeholder) {
      return placeholder;
    } else {
      return false;
    }
  }

  getIndex(value) {
    const { options } = this.props;
    const pos = options.findIndex(element => element.value == value);

    return pos;
  }

  /* Event handlers */

  handleBlur(event) {
    const {
      handleBlur,
      inputDateCp,
      onFocusDate,
    } = this.props;

    if (handleBlur) {
      handleBlur(event.target.value);
    }

    if (inputDateCp) {
      onFocusDate(false);
    }

    this.setState({
      inFocus: false,
    });
  }

  handleFocus() {
    const {
      inputDateCp,
      onFocusDate,
    } = this.props;

    this.setState({
      inFocus: true,
    });

    if (inputDateCp) {
      onFocusDate(true);
    }
  }

  handleOptionSelect = (e) => {
    const {
      onSelect,
      options,
    } = this.props;
    let { selectedOption } = this.state;
    const prevIndex = selectedOption;

    const prevOption = options[prevIndex] ? options[prevIndex].value : null;
    selectedOption = this.getIndex(e.target.value);
    const hasSelectedOption = selectedOption !== undefined && selectedOption !== null;

    if (hasSelectedOption) {
      this.setState({
        selectedOption: selectedOption,
      });
    }

    if (onSelect && hasSelectedOption && options?.[selectedOption]?.value) {
      onSelect(selectedOption, options[selectedOption].value, prevIndex, prevOption);
    }
  }
}
export default Dropdown;
